import endpointFromHostname from './helpers/endpointFromHostname';
import redirectFromHostname from './helpers/redirectFromHostname';
import authEndpointFromHostname from './helpers/authEndpointFromHostname';

/**
 * Paths
 *
 * @type {Object}
 */
const Paths = {
  root: endpointFromHostname(window.location.host),
  redirect: redirectFromHostname(window.location.host),
  auth: authEndpointFromHostname(window.location.host),
  path: {
    done: '/signup/final'
  },
  path_b: {
    final: '/signup/business'
  }
};

export default Paths;
